import React from 'react';
import './TranscriptView.css';

interface TranscriptMetadata {
    StartTime: string;
    StreamId: string;
    SourceLanguage: string;
    SessionId: string;
}

interface TranscriptMessage {
    index: number;
    timestamp: string;
    speaker: string;
    language: string;
    text: string;
}

interface TranscriptViewProps {
    content: { [key: string]: string };
}

const TranscriptView: React.FC<TranscriptViewProps> = ({ content }) => {
    const parseTranscript = (content: string) => {
        const lines = content.split('\n').filter(line => line.trim());
        const metadata: TranscriptMetadata = JSON.parse(lines[0]);
        const messages: TranscriptMessage[] = lines.slice(1).map(line => JSON.parse(line));
        return { metadata, messages };
    };

    const formatDateTime = (dateStr: string) => {
        return new Date(dateStr).toLocaleString();
    };

    const getLanguageDisplay = (code: string) => {
        const languages: Record<string, string> = {
            'en-US': 'English',
            'cmn-Hans-CN': 'Chinese (Simplified)',
            'cmn-Hant-TW': 'Chinese (Traditional)'
        };
        return languages[code] || code;
    };

    return (
        <div className="transcript-view">
            {Object.entries(content).map(([sessionId, text]) => {
                const { metadata, messages } = parseTranscript(text);
                return (
                    <div key={sessionId} className="transcript-section">
                        <h3 className="transcript-title">{sessionId.split('/').pop()}</h3>
                        <div className="transcript-content">
                            <div className="transcript-metadata">
                                <h3>Session Information</h3>
                                <div className="metadata-grid">
                                    <div className="metadata-item">
                                        <span className="label">Start Time:</span>
                                        <span className="value">{formatDateTime(metadata.StartTime)}</span>
                                    </div>
                                    <div className="metadata-item">
                                        <span className="label">Stream:</span>
                                        <span className="value">{metadata.StreamId}</span>
                                    </div>
                                    <div className="metadata-item">
                                        <span className="label">Source Language:</span>
                                        <span className="value">{getLanguageDisplay(metadata.SourceLanguage)}</span>
                                    </div>
                                    <div className="metadata-item">
                                        <span className="label">Session ID:</span>
                                        <span className="value">{metadata.SessionId}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="transcript-messages">
                                {messages.map((msg, index) => (
                                    <div key={index} className="message">
                                        <div className="message-header">
                                            <span className="time">{formatDateTime(msg.timestamp)}</span>
                                            <span className="language">{getLanguageDisplay(msg.language)}</span>
                                            {msg.speaker && <span className="speaker">Speaker: {msg.speaker}</span>}
                                        </div>
                                        <div className="message-text">{msg.text}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TranscriptView;
